import React from 'react';
import {
  CheckCircle,
  Clock,
  CreditCard,
  Lightning,
  Pause,
  ShieldCheck,
  WarningCircle,
  XCircle
} from '@phosphor-icons/react';

const AgentBillingBadge = ({ billingStatus, isActive, compact = false }) => {
  // Determine status to display
  // If no billing subscription but agent is active → manually activated (admin-enabled)
  // If billing subscription exists → use that status
  // Otherwise → inactive
  const status = billingStatus 
    ? billingStatus 
    : (isActive ? 'manually_activated' : 'inactive');

  // Status configurations
  const statusConfig = {
    active: {
      label: 'Active',
      icon: CheckCircle,
      color: 'text-[#14F195]',
      bgColor: 'bg-[#14F195]/20',
      borderColor: 'border-[#14F195]/30'
    },
    manually_activated: {
      label: 'Manually Activated',
      icon: ShieldCheck,
      color: 'text-[#8B5CF6]',
      bgColor: 'bg-[#8B5CF6]/20',
      borderColor: 'border-[#8B5CF6]/30'
    },
    pending_payment: {
      label: 'Pending Payment',
      icon: Clock,
      color: 'text-[#F59E0B]',
      bgColor: 'bg-[#F59E0B]/20',
      borderColor: 'border-[#F59E0B]/30'
    },
    trialing: {
      label: 'Trial',
      icon: Lightning,
      color: 'text-[#6366F1]',
      bgColor: 'bg-[#6366F1]/20',
      borderColor: 'border-[#6366F1]/30'
    },
    past_due: {
      label: 'Payment Failed',
      icon: WarningCircle,
      color: 'text-[#F97316]',
      bgColor: 'bg-[#F97316]/20',
      borderColor: 'border-[#F97316]/30'
    },
    canceled: {
      label: 'Canceled',
      icon: XCircle,
      color: 'text-[#EF4444]',
      bgColor: 'bg-[#EF4444]/20',
      borderColor: 'border-[#EF4444]/30'
    },
    suspended: {
      label: 'Suspended',
      icon: Pause,
      color: 'text-[#A0AEC0]',
      bgColor: 'bg-[#A0AEC0]/20',
      borderColor: 'border-[#A0AEC0]/30'
    },
    inactive: {
      label: 'Not Activated',
      icon: CreditCard,
      color: 'text-[#A0AEC0]',
      bgColor: 'bg-[#A0AEC0]/20',
      borderColor: 'border-[#A0AEC0]/30'
    }
  };

  const config = statusConfig[status] || statusConfig.inactive;
  const Icon = config.icon;

  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-semibold ${config.color} ${config.bgColor} border ${config.borderColor}`}>
        <Icon size={12} />
        {config.label}
      </span>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-xl ${config.bgColor} border ${config.borderColor}`}>
      <Icon size={16} className={config.color} />
      <span className={`font-semibold text-sm ${config.color}`}>
        {config.label}
      </span>
    </div>
  );
};

export default AgentBillingBadge;
